<template>
  <StagewiseToolbar :config="config" />
  <div class="container">
    <router-view :key="$route.fullPath" v-slot="{ Component }">
      <transition name="fade">
        <KeepAlive :include="include" :max="10">
          <component :is="Component" />
        </KeepAlive>
      </transition>
    </router-view>
  </div>
</template>

<script setup>
import { useApi } from '@/hooks/useApi';
import { useMarkers } from '@/store/src/markers';

const store = useMarkers();
const $route = useRoute();
const include = ref([]);
watch(
  () => $route,
  (to, from) => {
    if (to.meta.keepAlive) {
      !include.value.includes(to.name) && include.value.push(to.name);
    }
    if (from.meta.keepAlive && to.meta.deepth < from.meta.deepth) {
      let index = include.value.indexOf(from.name);
      index !== -1 && include.value.splice(index, 1);
    }
  }
);
useApi({
  url: 'Index/getOpenSystemConfig'
}).then(({ data }) => {
  store.setMarkerManage(data.digital_resource_location);
});
</script>

<style scoped lang="scss"></style>
